// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lkKe","type":"styles_type__LKfVH","choices":"styles_choices__3KU30"};